// extracted by mini-css-extract-plugin
module.exports = {"title":"label-title-component_title__2tig0"};